<div class="ui-g-12 ui-md-6">
  <!-- Button visualizza Filtrati per Catalogo Attivo -->
  <button
    pButton
    class="k-generic-btn"
    type="button"
    (click)="getResults(false)"
    label="{{ 'reservations.filteredByActiveCatalog' | translate }}"
    [disabled]="!showAllResults">
  </button>
  <!-- Button visualizza Tutte -->
  <button
    pButton
    class="k-generic-btn"
    type="button"
    (click)="getResults(true)"
    label="{{ 'common.all' | translate }}"
    [disabled]="showAllResults">
  </button>
</div>
<div class="ui-g-12 ui-md-6"></div>
<!-- Tabella Ricezione Premi -->
<div class="ui-g-12">
  <app-kontable
    #table
    title="{{ 'catalog.reservationCatalog' | translate }}"
    [columns]="[
      {field: 'id', title: 'ID'},
      {field: 'store_name', title: 'common.store_title', bodyTemplate: store},
      {field: 'dt_received', title: 'catalog.dateReceivedGiftStore', type: 'date', filterType: dateFilter},
      {field: 'ship_note', title: 'catalog.shipNote'},
      {field: 'stato', bodyTemplate: stateRes, title: 'reservations.status' , filterType: selectFilter, filterOptions: {values: reservationTypes}}
    ]"
    [service]="service"
    (onAdd)="addCatalog()"
    [paginationType]="paginationType"
    [showRecoverButton]="false"
    [showInfoButton]="false"
    [showAddButton]="true"
    [showDeleteButton]="false"
    [showDetailsButton]="false"
    [additionalRowCommands]="customRow"
    [showEditButton]="false"
    [showReport]="true"
  >

    <ng-template #stateRes data-testid="stateRes" let-row let-value="value">
      <!--<span *ngIf="value == 1" class="fa fa-check" title="Valid"></span>-->
      <!-- la query che restituisce i reservationTypes fa una getParams (su loyalty) in ordine crescente per id-->
      <span *ngIf="value == 0" >{{reservationTypes[1].label}}</span><!-- Già assegnati -->
      <span *ngIf="value == 1" >{{reservationTypes[2].label}}</span><!--Da assegnare -->
      <span *ngIf="value == 2" ></span>
      <span *ngIf="value == 3" >{{reservationTypes[3].label}}</span><!--parzialmente assegnati -->
    </ng-template>

    <!-- Template negozio-->
    <ng-template #store data-testid="store" let-row>
      <span>{{row.host_code}} - {{row.store_name}}</span>
    </ng-template>

    <!-- Bottoni custom -->
    <ng-template #customRow data-testid="customRow" let-row>
      <!-- Pagina di dettaglio relativa -->
      <p-button *ngIf="row['stato'] == 0 || row['stato'] == 3" pTooltip="{{ 'common.view' | translate }}" icon="fa fas fa-eye" styleClass="ui-button-info" (onClick)="showDetails(row.id)"></p-button>
      <!-- Edit relativo al record-->
      <p-button *ngIf="row['stato'] ==1 || row['stato']== 3 || row['stato'] == 2" pTooltip="{{ 'common.edit' | translate }}" icon="fa fas fa-edit" styleClass="ui-button-info" (onClick)="editCatalog(row.id)"></p-button>
    </ng-template>

  </app-kontable>
</div>



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-catalog-gift-received-store/loyalty-catalog-gift-received-store.component.html